export function catchOutsideClicks(refNode, callback) {
  document.body.addEventListener("click", event => {
    if (refNode != null) {
      if (!refNode.contains(event.target)) callback();
    }
  });
}
